import { render, staticRenderFns } from "./edgeProtection.vue?vue&type=template&id=7680f0a8&scoped=true&"
import script from "./edgeProtection.vue?vue&type=script&lang=js&"
export * from "./edgeProtection.vue?vue&type=script&lang=js&"
import style0 from "./edgeProtection.vue?vue&type=style&index=0&id=7680f0a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7680f0a8",
  null
  
)

export default component.exports